
// Update header height
function updateSize() {
    let header = document.getElementById('header');
    let headerHeight = header.offsetHeight;
    let main = document.getElementById('content');
    main.style.paddingTop = headerHeight + 'px';
}

document.addEventListener('DOMContentLoaded', updateSize);
window.addEventListener("resize", updateSize);

// ES6 Arrow Function
const getHash = () => window.location.hash;
// ES6 Object Method Shorthand
const isMobile = {
    Android() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows() {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any() {
        return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
    }
};

// Replacing jQuery's $.urlParam
const urlParam = (name) => {
    const results = new RegExp(`[\\?&]${name}=([^&#]*)`).exec(window.location.href);
    return results ? results[1] || 0 : null;
};
// Touch Support
const supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

// Scroll Overrides
if (window.location.hash) {
    window.scrollTo({
        top: 0,
        behavior: 'instant'
    });
}
function anchorScroll() {
    //find all links that start with #
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            let id = this.getAttribute('href').replace("#","").trim();
            let offset = document.getElementById('header').offsetHeight;
            let element = document.getElementById(id);
            if(!element) {
                return;
            }else{
                window.scrollTo({
                    top: element.offsetTop - offset,
                    behavior: 'smooth'
                });
            }

        });
    });
}
anchorScroll();

function scrollOnPageLoad() {
    const hashLink = window.location.hash;
    if (document.getElementById(hashLink.slice(1).length)) {
        // *only* if we have anchor on the url
        // smooth scroll to the anchor id
        let offset = document.getElementById('header').offsetHeight;
        if(typeof document.querySelector(window.location.hash) == "undefined") {
            return;
        }
        if (document.querySelector(window.location.hash)) {
            window.scrollTo({
                top: document.querySelector(window.location.hash).offsetTop - offset,
                behavior: 'smooth'
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (supportsTouch) {
        const links = document.querySelectorAll('a');
        links.forEach((link) => {
            link.classList.add('touch');
        });
    }
    if (window.location.hash) {
        window.scrollTo({
            top: 0,
            behavior: 'instant'
        });
    }
    setTimeout(() => {
        scrollOnPageLoad();
    }, 500);
});
klaroCloseButton = null;
window.runKlaro = function() {
    klaro.show();
    setTimeout(function() {
        const klaroElement = document.getElementById('klaro');
        const klaroCloseButton = klaroElement.querySelector('.hide');
        klaroCloseButton.focus();
        const focusableElements = klaroElement.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement = focusableElements[focusableElements.length - 1];
        document.addEventListener('keydown', function(e) {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
            if (!isTabPressed) {
                return;
            }
            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            }
        });
        klaroCloseButton.addEventListener('click', function() {
            const acceptButton = document.querySelector('button.button.is-success');
            acceptButton.focus();
        });
    },50);
}

// site alert local storage
if(document.querySelector('.btn-close')) {
    document.querySelector('.btn-close').addEventListener('click', function (e) {
        sessionStorage.setItem("alertWasShown", "true");
    });

    if (!sessionStorage.getItem("alertWasShown")) {
        document.querySelector('.alert-dismissible').style.display = "block";
        document.querySelector('.alert-dismissible').setAttribute('aria-hidden','false');
    } else {
        document.querySelector('.alert-dismissible').style.display = "none";
        document.querySelector('.alert-dismissible').setAttribute('aria-hidden','true');
    }
}
